import React from 'react';

const SvgLi = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="LI_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="LI_svg__b" fill="#fff">
        <use xlinkHref="#LI_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#LI_svg__a" />
      <path fill="#0A3B97" mask="url(#LI_svg__b)" d="M0 0h28v10.667H0z" />
      <path fill="#E6273E" mask="url(#LI_svg__b)" d="M0 10.667h28V20H0z" />
    </g>
  </svg>
);

export default SvgLi;
